import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que devuelve el mes de la fecha pasada en castellano o gallego según lo indicado.
 *
 * @author lreverendo
 *
 * @version 01.02.0000
 * @since 01.02.0000
 */
@Pipe({
  name: 'mes'
})
export class MesPipe implements PipeTransform {
  public transform(value: string, idioma: string = 'gl'): string {
    const mesesGL: string[] = [
      'Xaneiro',
      'Febreiro',
      'Marzo',
      'Abril',
      'Maio',
      'Xuño',
      'Xullo',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Decembro'
    ];
    const mesesES: string[] = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ];
    const mesesEN: string[] = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    if (value === '' || value === null) {
      return '';
    }

    const date = new Date(parseInt(value, 10));
    let mes = mesesES[date.getMonth()];
    if (idioma === 'gl') {
      mes = mesesGL[date.getMonth()];
    }
    if (idioma === 'en') {
      mes = mesesEN[date.getMonth()];
    }

    return mes;
  }
}
